// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_h7-0";
export var actionModalContentContainer = "_h7-1";
export var createTagButton = "_h7-2";
export var footerContainer = "_h7-7";
export var fullWidthDivider = "_h7-3";
export var hasCreateTagButton = "_h7-4";
export var noCreateTagButton = "_h7-5";
export var tagsContainer = "_h7-6";
export var tagsModalContentContainer = "_h7-8";